<div class="container mt-2 pb-4">
  <div class="row">
    <div class="video-container" #videoContainer>
      <video id="video-player" class="video-player video-js vjs-default-skin" controls playsinline webkit-playsinline
        poster="../../../../assets/images/video_banner_lucky_loot.png" (click)="onVideoClick()">
        <source [src]="rouletteVideoUrl" *ngIf="rouletteVideoUrl && !rouletteVideoUrl.includes('.m3u8')" />
        <source [src]="rouletteVideoUrl" *ngIf="rouletteVideoUrl?.includes('.m3u8')" type="application/x-mpegURL" />
      </video>
    </div>
  </div>

  <div class="row">
    <div class="betting-container">
      <!-- <div class="header"> -->
        <div class="event-box">
          <div class="currentEventName">{{CurrentEventName}}</div>
          <div class="event-right">  
            <button 
              class="btn-result" 
              type="button"
              data-toggle="modal" 
              data-target="#raceresultModal"
            >
              <i class="bi bi-card-text"></i>
              {{'COMMON.RESULTS' | translate}}
            </button>
          </div>
        </div>
        <div class="event-box">

          <div class="event-left">Next Draw : <span class="timer">{{NextDrowEventCode}}</span></div>
          <div class="event-right"> <i class="bi bi-clock"></i><span class="timer">{{ timerDisplay }}</span></div>
        </div>
      <!-- </div> -->

      <div class="gradient-line"></div>
    </div>
  </div>

  <div class="row lucky-loot">
    <div class="lotto-container">
      <!-- <div class="header">
        <div class="next-draw">Next Draw <span class="timer">{{ timerDisplay }}</span></div>

        <div class="repeat-section">
          <label>REPEAT</label>
          <select [(ngModel)]="repeatCount">
            <option *ngFor="let count of repeatOptions" [value]="count">{{ count }}</option>
          </select>
        </div>
      </div> -->

     <!-- CIRCLES GRID -->
      <div class="numbers-grid">
        <button
          *ngFor="let num of numbers; let i = index"
          [ngClass]="[
            'number-btn',
            getColor(i),
            selectedNumbers.includes(num) ? 'selected' : ''
          ]"
          (click)="toggleSelect(num, i)"
        >
          {{ num }}
        </button>
      </div>
      
      <div class="actions">
        <div class="quick-pick">Quick Pick</div>
        <div class="numbers" (click)="quickPick(6)">6</div>
        <div class="numbers" (click)="quickPick(5)">5</div>
        <div class="numbers" (click)="quickPick(4)">4</div>
        <button class="clear" (click)="clearSelection()">
          Delete
          <i class="bi bi-trash"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="row result-container" *ngIf="selectedAll.length > 0">
    <div class="numbers-showing-container">
      <div class="numbers" [ngClass]="num.color"  *ngFor="let num of selectedAll; let i = index">{{num.number}}</div>
    </div>
  </div>

  <!-- RESULT BOX SECTION -->
  <!-- <div class="row result-container">
    <div class="result-box" *ngFor="let item of resultBoxes">
      <div class="circle" [ngClass]="item.color">{{ item.number }}</div>
      <div class="label">{{ item.label }}</div>
      <div class="value">{{ item.value }}</div>
    </div>
  </div> -->

  <div class="row main-container">
    <!-- Number Grid -->
    <div class="grid-container">
      <div class="column" *ngFor="let column of columns">
        <div
          class="number-box"
          *ngFor="let box of column"
          [ngClass]="[box.color, box.selected ? 'selected' : '']"
          (click)="toggleBox(box)"
        >
          <div class="circle" [ngClass]="box.circleColor"></div>
          <div class="circle-text">{{ box.circleText }}</div>
          <div class="main-number">{{ box.mainNumber }}</div>
          <div class="small-number">{{ box.smallNumber }}</div>
        </div>
      </div>
    </div>

    <!-- Sum of Draw Section -->
    <div class="sum-container">
      <div
        class="sum-box"
        *ngFor="let item of sumDraws; let i = index"
        [class.selected]="item.selected"
        (click)="toggleSumDraw(item, i)"
      >
        <div class="sum-label">
          <span>Sum Of Draw</span><br>
          <strong>{{ item.label }}</strong>
        </div>
        <div class="sum-value">{{ item.value }}</div>
      </div>
    </div>
  </div>


  <!-- Result Modal -->
  <div class="modal fade" id="raceresultModal" data-backdrop="false" tabindex="100000" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document" style="margin-left: 0px;margin-right: 0px;">
      <div class="modal-content" style="margin-top: 200px;margin-bottom: 100px;">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{'COMMON.RESULTS' | translate}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span style="font-size: 35px;" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <button class="price-table-btn" (click)="openPriceTable()">
            View Price Table
          </button>

          <div class="price-table-overlay" *ngIf="showPriceTable">
            <div class="price-table-modal">
              
              <button class="close-btn" (click)="closePriceTable()">✕</button>
          
              <app-image-zoom-viewer
                src="assets/images/lucky_loot_Prize_Table.jpg"
                alt="Price Table"
                [maxZoom]="4"
                [zoomStep]="0.5"
              ></app-image-zoom-viewer>
            </div>
          </div>

          <div *ngFor="let item of kironResults" class="race-preview shadow p-0 mb-2">
            <div class="race-header bg-fill-secondary text-white">
              <div class="race-info">
                <div class="race-name text-uppercase">{{item.eventName}}</div>
                <div class="race-description text-uppercase">Game: {{item.eventCode}}</div>
              </div>
              <div class="race-extra">
                {{item.eventTimeUTC.substr(11,5)}}
                <span class="secondary">{{item.eventTimeUTC.substr(0,10)}}</span>
              </div>
            </div>

            <div class="race-content">
              <div *ngIf="item.isKLL" class="race-content kll" >
                <table class="racing-table table-borderless table-striped">
                  <thead>
                    <tr>
                      <th></th>
                      <th class="text-left">RESULT</th>
                    </tr>
                  </thead>
                  <tbody>
        
                    <tr>
                      <td>FIRST 6</td>
                      <td>
                        <div class="icon-box">
                          <div *ngFor="let position of item?.eventPositions" class="dib">
                            <span 
                            [ngClass]="{'bonus-ball': checkBonusBall(position,item.kllBonusBall),'red-button': checkBallColor(position) == 'red', 'blue-button' : checkBallColor(position) == 'blue' , 'green-button': checkBallColor(position) == 'green', 'yellow-button' : checkBallColor(position) == 'yellow'}"
                            class="numberCircle">{{position.selectionNumber}}</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr >
                      <td>FIRST 5</td>
                      <td>
                        <div class="icon-box">
                          <div *ngFor="let position of item?.eventPositions | slice:0:5" class="dib">
                            <span 
                            [ngClass]="{'bonus-ball': checkBonusBall(position,item.kllBonusBall),'red-button': checkBallColor(position) == 'red', 'blue-button' : checkBallColor(position) == 'blue' , 'green-button': checkBallColor(position) == 'green', 'yellow-button' : checkBallColor(position) == 'yellow'}"
                            class="numberCircle">{{position.selectionNumber}}</span>
                          </div>                    
                        </div>
                      </td>
                    </tr>
                    <tr >
                      <td>FIRST 4</td>
                      <td>
                        <div class="icon-box">
                          <div *ngFor="let position of item?.eventPositions | slice:0:4" class="dib">
                            <span 
                            [ngClass]="{'bonus-ball': checkBonusBall(position,item.kllBonusBall),'red-button': checkBallColor(position) == 'red', 'blue-button' : checkBallColor(position) == 'blue' , 'green-button': checkBallColor(position) == 'green', 'yellow-button' : checkBallColor(position) == 'yellow'}"
                            class="numberCircle">{{position.selectionNumber}}</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr  >
                      <td>FIRST 3</td>
                      <td>
                        <div class="icon-box">
                          <div *ngFor="let position of item?.eventPositions | slice:0:3" class="dib">
                            <span 
                            [ngClass]="{'bonus-ball': checkBonusBall(position,item.kllBonusBall),'red-button': checkBallColor(position) == 'red', 'blue-button' : checkBallColor(position) == 'blue' , 'green-button': checkBallColor(position) == 'green', 'yellow-button' : checkBallColor(position) == 'yellow'}"
                            class="numberCircle">{{position.selectionNumber}}</span>
                          </div> 
                        </div>
                      </td>
                    </tr>
                    <tr >
                      <td>FIRST 2</td>
                      <td>
                        <div class="icon-box">
                          <div *ngFor="let position of item?.eventPositions | slice:0:2" class="dib">
                            <span 
                            [ngClass]="{'bonus-ball': checkBonusBall(position,item.kllBonusBall),'red-button': checkBallColor(position) == 'red', 'blue-button' : checkBallColor(position) == 'blue' , 'green-button': checkBallColor(position) == 'green', 'yellow-button' : checkBallColor(position) == 'yellow'}"
                            class="numberCircle">{{position.selectionNumber}}</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr  >
                      <td>FIRST BALL</td>
                      <td>
                        <div class="icon-box">
                          <div *ngFor="let position of item?.eventPositions | slice:0:1" class="dib">
                            <span 
                            [ngClass]="{'bonus-ball': checkBonusBall(position,item.kllBonusBall),'red-button': checkBallColor(position) == 'red', 'blue-button' : checkBallColor(position) == 'blue' , 'green-button': checkBallColor(position) == 'green', 'yellow-button' : checkBallColor(position) == 'yellow'}"
                            class="numberCircle">{{position.selectionNumber}}</span>
                          </div>                     
                        </div>
                      </td>
                    </tr>
                    <tr  >
                      <td>FIRST COLOR</td>
                      <td>
                        <div class="icon-box">
                          <div *ngFor="let position of item?.eventPositions | slice:0:1" class="dib">
                            <span 
                            [ngClass]="{'red-button': checkBallColor(position) == 'red', 'blue-button' : checkBallColor(position) == 'blue' , 'green-button': checkBallColor(position) == 'green', 'yellow-button' : checkBallColor(position) == 'yellow'}"
                            class="numberCircle"></span>
                          </div>                     
                        </div>
                      </td>
                    </tr>
                    <tr  >
                      <td>SOD ODD/EVEN</td>
                      <td class="text-left">{{item?.kllWinnerSodOddEven}}</td>
                    </tr>
                    <tr  >
                      <td>SOD OVER/UNDER</td>
                      <td class="text-left">{{item?.kllWinnerSodOverUnder}}</td>
                    </tr>
                    
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
</div> 